import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { StatusColeta } from '../Configs/Status';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { TbCheck, TbChecklist, TbNotes, TbTruckDelivery, TbTruckLoading, TbTruckOff, TbTruckReturn } from 'react-icons/tb';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient(136deg, #4F8E2E 0%, #74B054 50%, #A1D386 100%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient(136deg, #4F8E2E 0%, #74B054 50%, #A1D386 100%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative', // Adicionado para posicionar corretamente a animação
  overflow: 'hidden', // Adicionado para esconder qualquer overflow da animação
  ...(ownerState.active && {
    backgroundImage: 'linear-gradient(136deg, #4F8E2E 0%, #74B054 50%, #A1D386 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    animation: 'pulse 2s infinite', // Adicionado para aplicar a animação de pulsação
  }),
  ...(ownerState.completed && {
    backgroundImage: 'linear-gradient(136deg, #4F8E2E 0%, #74B054 50%, #A1D386 100%)',
  }),
  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 0 0 0 rgba(161, 211, 134, 0.7)',
    },
    '50%': {
      boxShadow: '0 0 15px 15px rgba(161, 211, 134, 0)',
    },
    '100%': {
      boxShadow: '0 0 0 0 rgba(161, 211, 134, 0)',
    },
  },
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <TbTruckOff size={23} />,
    2: <TbNotes size={23} />,
    3: <TbChecklist size={23} />,
    4: <TbTruckDelivery size={23} />,
    5: <TbTruckReturn size={23} />,
    6: <TbTruckLoading size={23} />,
    7: <TbCheck size={23} />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const steps = StatusColeta.getArrayItems();

export default function StatusStepper({ statusIndex }) {

  return (
    <Stack sx={{ width: '100%' }} spacing={4}>
      <Stepper alternativeLabel activeStep={statusIndex} connector={<ColorlibConnector />}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
}